import styled from 'styled-components'
import { theme } from '../../../styles/theme'
import { mq } from '../../../styles/mq'
export const Container = styled.div`
  position: relative;
  max-width: 50em;
  margin-inline: auto;
  margin-bottom: 2em;
`

export const IconsContainer = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  ${mq.smallOnly} {
    width: 100%;
  }
  width: calc(120px * 2 + 20px);
  margin: 4rem auto;
  column-gap: 20px;
  row-gap: 46px;
  ${mq.medium} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    width: calc(160px * 4 + 20px * 3);
    margin: 6rem auto;
  }
  ${mq.large} {
    width: calc(210px * 4 + 20px * 3);
  }
`
export const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 2rem;

  ${mq.smallOnly} {
    width: 100%;
    aspect-ratio: 1;
    height: auto;
  }

  width: 120px;
  height: 118px;

  ${mq.medium} {
    width: 160px;
    height: 154px;
    border-radius: 3rem;
  }

  ${mq.large} {
    border-radius: 4rem;
    width: 210px;
    height: 202px;
  }

  box-shadow: 4px 4px 15px rgba(18, 36, 45, 0.2);
  filter: drop-shadow(4px 4px 15px rgba(18, 36, 45, 0.2));
  transition: all 0.3s;
  background: rgba(255, 255, 255, 0.4);
  cursor: pointer;

  &:nth-child(1) {
    svg {
      width: 46px;
      ${mq.large} {
        width: 59px;
      }
    }
  }
  &:nth-child(2) {
    svg {
      width: 60px;
      ${mq.large} {
        width: 89px;
      }
    }
  }
  &:nth-child(3) {
    svg {
      width: 52px;
      ${mq.large} {
        width: 74px;
      }
    }
  }
  &:nth-child(4) {
    svg {
      width: 64px;
      ${mq.large} {
        width: 86px;
      }
    }
  }
  &:hover {
    box-shadow: 2px 2px 15px rgba(18, 36, 45, 0.1);
    filter: drop-shadow(2px 2px 15px rgba(18, 36, 45, 0.1));
  }
`
export const Title = styled.h3`
  text-align: center;
`
export const Description = styled.p`
  text-align: center;
`
export const Label = styled.div`
  position: absolute;
  top: 100%;
  text-align: center;
  font-family: 'Skolar Sans PE Condensed', sans-serif;
  font-weight: 800;
  font-size: 1.9rem;
  ${mq.medium} {
    font-size: 1.9rem;
  }
  ${mq.large} {
    font-size: 2.1rem;
  }
  ${mq.xlarge} {
    font-size: 2.4rem;
  }
  margin-top: 1rem;
`

export const Popup = styled.div`
  width: 100%;
  border-radius: 2rem;
  padding: 2rem;

  ${mq.medium} {
    border-radius: 3rem;
    padding: 2.4rem 3.6rem 2.4rem 2.4rem;
  }

  ${mq.large} {
    padding: 2.4rem 4rem 2.4rem 2.4rem;
  }

  ${mq.xlarge} {
    padding: 2.4rem 4.6rem 2.4rem 2.4rem;
    border-radius: 4rem;
  }

  background: ${theme.colors.background};

  &:before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 2rem;

    ${mq.medium} {
      border-radius: 3rem;
    }

    ${mq.xlarge} {
      border-radius: 4rem;
    }
  }
`
export const PopupIcon = styled.div`
  display: none;

  ${mq.medium} {
    display: flex;
    float: left;
  }

  position: relative;
  justify-content: center;
  align-items: center;
  width: 208px;
  margin-right: 3.2rem;
  border-radius: 3rem;

  ${mq.large} {
    border-radius: 4rem;
  }

  border: 1px solid rgba(255, 255, 255, 0.8);

  svg {
    width: 100%;
  }
`
export const IconCont1 = styled.div`
  width: 36px;
  ${mq.medium} {
    width: 46px;
  }
  ${mq.large} {
    width: 59px;
  }
`
export const IconCont2 = styled.div`
  width: 56px;
  ${mq.medium} {
    width: 60px;
  }
  ${mq.large} {
    width: 89px;
  }
`
export const IconCont3 = styled.div`
  width: 32px;
  ${mq.medium} {
    width: 52px;
  }
  ${mq.large} {
    width: 74px;
  }
`
export const IconCont4 = styled.div`
  width: 52px;
  ${mq.medium} {
    width: 64px;
  }
  ${mq.large} {
    width: 86px;
  }
`
export const PopupText = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;

  h4 {
    font-family: 'Skolar Sans PE Condensed', sans-serif;
    font-weight: 800;
    ${mq.smallOnly} {
      font-size: 1.7rem;
    }
    font-size: 1.9rem;
    ${mq.medium} {
      margin-top: 4px;
      font-size: 2.1rem;
    }
    ${mq.large} {
      margin-top: 6px;
      font-size: 2.4rem;
    }
    ${mq.xlarge} {
      margin-top: 8px;
      font-size: 2.7rem;
    }
    margin: 0;
  }
  display: flex;
  flex-direction: column;

  > div:nth-child(2) {
    padding-right: 8px;
    margin-top: 16px;

    p:first-child {
      margin-top: 0;
    }
  }
`
export const PopupClose = styled.div`
  position: absolute;
  padding: 8px;
  cursor: pointer;
  font-size: 0;
  ${mq.smallOnly} {
    top: 12px;
    right: 12px;
  }
  top: 10px;
  right: 10px;
  ${mq.medium} {
    top: 24px;
    right: 24px;
  }
  ${mq.large} {
    top: 28px;
    right: 28px;
  }
  ${mq.xlarge} {
    top: 32px;
    right: 32px;
  }
  svg {
    ${mq.smallOnly} {
      width: 12px;
      height: 12px;
    }
    width: 16px;
    height: 16px;
    ${mq.medium} {
      width: 20px;
      height: 20px;
    }
    ${mq.large} {
      width: 20px;
      height: 20px;
    }
    ${mq.xlarge} {
      width: 24px;
      height: 24px;
    }
  }
`
